import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ClaimCellEm = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const ClaimCellText = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const ClaimShortText = styled.span<{ $open?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${({ $open }) => ($open ? tokens.status.warning.fg : tokens.text.secondary)};
`

export const ClaimNoteText = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
